<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="sa-flexbox-body-left" v-if="!modalMode">
                    <vc-calendar :attributes="attributes" transition="fade" show-weeknumbers="left" nav-visibility="hidden" @dayclick="onDayClick" />

                    <span class="sa-badge-legend sa-badge-legend-red">Assente</span>
                    <span class="sa-badge-legend sa-badge-legend-yellow">Uscita Programmata</span>
                    <span class="sa-badge-legend sa-badge-legend-green">Presente</span>
                </div>
                <div class="sa-flexbox-body-content">
                    <div class="sa-flexbox" style="padding-bottom: 20px">
                        <div class="sa-flexbox-header">
                            <div class="sa-toolbar">
                                <div class="sa-toolbar-title"><span v-if="!modalMode" class="sa-flexbox-body-title">Uscite</span></div>
                                <div class="sa-toolbar-separator"></div>
                                <div class="sa-toolbar-button">
                                    <b-button v-if="!modalMode" size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" :hidden="btnNuovaUscitaHidden" @click="onClickUscitaProgrammata" class="mb-2">
                                        <font-awesome-icon icon="plus"></font-awesome-icon>
                                        Aggiungi
                                    </b-button>
                                </div>
                                <div class="sa-toolbar-button">
                                    <b-button v-if="enablePrintButton" size="sm" variant="outline-purple outline-primary-noborder  sa-margin-right float-sm-right" @click="onClickStampa()">
                                        <font-awesome-icon icon="print"></font-awesome-icon>
                                        Stampa
                                    </b-button>
                                </div>
                            </div>
                        </div>
                        <div class="sa-flexbox-body">
                            <div style="width: 100%" class="b-table-sticky-header">
                                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" table-class="sa-b-table" @row-clicked="onRowClicked">
                                    <template #cell(index)="row">
                                        {{ (currentPage - 1) * perPage + row.index + 1 }}
                                    </template>

                                    <!-- Prima versione dei radio button per il momento disabilitata poiché ne uso un altra, abilitare il field per vederla -->
                                    <!-- <template v-if="modalMode && tipoOperazione === 'USCITA'" #cell(select)="{ item }">
                            <b-form-radio :checked="uscitaSelezionata && uscitaSelezionata.id === item.id" @change="onSelectUscita(item)" :disabled="!canSelectItem(item)" name="uscita-selection"> </b-form-radio>
                        </template> -->

                                    <template #cell(allNotes)="{ item }">
                                        <div>
                                            <div v-if="item.noteUscitaProgrammata && item.noteUscitaProgrammata.trim()" class="note-item">
                                                <span class="bold-label">Note Uscita Programmata:</span>
                                                <span>{{ item.noteUscitaProgrammata }}</span>
                                            </div>

                                            <div v-if="item.noteUscita && item.noteUscita.trim()" class="note-item">
                                                <span class="bold-label">Note Uscita:</span>
                                                <span>{{ item.noteUscita }}</span>
                                            </div>

                                            <div v-if="item.noteEntrata && item.noteEntrata.trim()" class="note-item">
                                                <span class="bold-label">Note Entrata:</span>
                                                <span>{{ item.noteEntrata }}</span>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-slot:cell(actions)="{ item }">
                                        <!-- Modalità normale: bottone modifica -->
                                        <b-button-group v-if="!modalMode">
                                            <b-container>
                                                <b-button size="sm" variant="outline-success" v-b-tooltip.hover title="Aggiorna presenza" @click="onClickPresenzaEdit(item)">
                                                    <font-awesome-icon icon="edit" />
                                                </b-button>

                                                <!-- Modalità normale: bottone visualizza (quando una uscita è stata completata) -->
                                                <b-button v-if="item.dataOraUscita && item.dataOraEntrata" size="sm" variant="outline-secondary" v-b-tooltip.hover title="Visualizza uscita" @click="onClickVisualizzaUscita(item)">
                                                    <font-awesome-icon icon="eye" />
                                                </b-button>
                                                <!-- Modalità normale: bottone uscita -->
                                                <b-button v-else-if="!item.dataOraUscita" size="sm" variant="outline-success" v-b-tooltip.hover title="Registra Uscita" @click="onClickRegistraUscita(item)">
                                                    <font-awesome-icon :icon="['fas', 'sign-in-alt']" />
                                                </b-button>
                                                <!-- Modalità normale: bottone uscita -->
                                                <b-button v-else v-b-tooltip.hover size="sm" variant="outline-danger" title="Registra Entrata" @click="onClickRegistraEntrata(item)" class="sa-icon-rotate">
                                                    <font-awesome-icon :icon="['fas', 'sign-in-alt']" />
                                                </b-button>

                                                <b-button v-b-tooltip.hover size="sm" variant="outline-danger" title="Elimina Uscita" @click="onClickDeleteUScita(item)">
                                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                                </b-button>
                                            </b-container>
                                        </b-button-group>
                                        <!-- Modalità selezione: bottone seleziona se me trovo in modalita modalMode = true -->
                                        <b-button v-else size="sm" :variant="getSelectButtonVariant(item)" v-b-tooltip.hover :title="getSelectButtonTitle(item)" @click="onSelectUscita(item)" :disabled="!canSelectItem(item)" :class="getSelectButtonClass(item)">
                                            <font-awesome-icon :icon="getSelectButtonIcon(item)" />
                                            {{ getSelectButtonText(item) }}
                                        </b-button>
                                    </template>
                                </b-table>
                            </div>
                        </div>
                        <div class="sa-flexbox-footer">
                            <div class="sa-list-component-footer" style="padding-bottom: 10px" v-if="!modalMode">
                                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                                    <b-col lg="3">
                                        <p>Record Totali: {{ rows }}</p>
                                    </b-col>
                                    <b-col lg="9">
                                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                                    </b-col>
                                </b-row>
                                <rsa-scheda-ospite-uscite-edit-component v-if="!modalMode" ref="cmpRsaSchedaOspiteUsciteEditComponent" @onSave="onSavePresenza" @onClose="onCloseModal"> </rsa-scheda-ospite-uscite-edit-component>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sa-flexbox-body-right"></div>
            </div>
        </div>
        <print-component v-show="false" ref="cmpPrint"></print-component>
    </div>
</template>
<script>
import RsaSchedaOspiteUsciteEditComponent from "./RsaSchedaOspiteUsciteEditComponent.vue";
import moment from "moment";
import UtilityMixin from "../../../utility/UtilityMixin";
import PrintComponent from "../../../utility/components/PrintComponent.vue";

//import Vue from "vue";
export default {
    name: "RsaSchedaOspiteUsciteListComponent",
    // emits: ["beforeLoadData", "afterLoadData"], da studiare bene questo
    mixins: [UtilityMixin],
    components: { RsaSchedaOspiteUsciteEditComponent, PrintComponent },
    props: {
        //jsonDataAccettazione: { type: Object },
        utente: { type: Object },
        modalMode: { type: Boolean, default: false },
        tipoOperazione: { type: String, default: null },
    },
    data() {
        return {
            jsonDataAccettazione: null,
            pathResource: "/rsapazientepresenze",
            btnNuovaUscitaHidden: false,
            showModalLoading: false,
            listKey: 0,
            rows: 0,
            perPage: 50,
            idAccettazione: null,
            isReadOnly: false,
            isDisabled: false,
            //  btnDeleteEnable: false,
            isEdit: true,
            currentPage: 1,
            items: [],
            enablePrintButton: true,
            filtroPresenze: {},
            uscitaSelezionata: null,
            attributes: [
                // {
                // 	key: "today",
                // 	highlight: {
                // 		color: "red",
                // 		fillMode: "light",
                // 		contentClass: "italic",
                // 	},
                // 	dates: new Date(2025, 10, 12),
                // },
                // {
                // 	highlight: {
                // 		color: "orange",
                // 		fillMode: "light",
                // 	},
                // 	dates: new Date(2025, 10, 13),
                // },
                // {
                // 	highlight: {
                // 		color: "green",
                // 		fillMode: "light",
                // 	},
                // 	dates: new Date(2025, 10, 14),
                // },
                // {
                // 	highlight: {
                // 		start: { fillMode: "light", color: "green" },
                // 		base: { fillMode: "light", color: "green" },
                // 		end: { fillMode: "light", color: "green" },
                // 	},
                // 	dates: { start: new Date(2025, 10, 1), end: new Date(2025, 10, 11) },
                // },
            ],
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Uscita Prog.",
                    key: "dataOraUscitaProgrammata",
                    formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("DD/MM/YYYY HH:mm");
                        } else {
                            return "-----";
                        }
                    },
                    sortable: true,
                },
                {
                    label: "Entrata Prog.",
                    key: "dataOraEntrataProgrammata",
                    formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("DD/MM/YYYY HH:mm");
                        } else {
                            return "-----";
                        }
                    },
                    sortable: true,
                },
                {
                    label: "Uscita",
                    key: "dataOraUscita",
                    formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("DD/MM/YYYY HH:mm");
                        } else {
                            return "-----";
                        }
                    },
                },
                {
                    label: "Entrata",
                    key: "dataOraEntrata",
                    formatter: (value) => {
                        if (value) {
                            return moment(new Date(value)).format("DD/MM/YYYY HH:mm");
                        } else {
                            return "-----";
                        }
                    },
                    sortable: true,
                },
                {
                    label: "Assente Nella Data",
                    key: "assenteNellaData",
                    formatter: (value) => {
                        if (value === true) return "SI";
                        if (value === false) return "NO";
                        return value === null || value === undefined ? "---" : value;
                    },
                },
                /* {
                    label: "Tipo",
                    key: "tipo",
                    thStyle: "width: 5rem",
                    sortable: true,
                }, */
                {
                    label: "Motivo",
                    key: "motivo",
                },
                {
                    label: "Note",
                    key: "allNotes",
                },
                /* {
                    label: "",
                    key: "select",
                }, */
                {
                    class: "sa-table-column-action-double",
                    key: "actions",
                    label: "",
                },
            ],
        };
    },
    mounted() {
        //console.log(this.jsonDataAccettazione);
        /* let me = this;
        this.filtroPresenze = { idAccettazione: me.idAccettazione };
        me.loadData(); */
        // console.log("Tipo operazione:", this.tipoOperazione);
        this.enablePrintButton = this.appConfig.enablePrintButton;
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        // ==================== METODI PRINCIPALI ====================
        init(jsonDataAccettazione) {
            let me = this;
            this.jsonDataAccettazione = jsonDataAccettazione;
            me.idAccettazione = jsonDataAccettazione.id;
            // me.btnDeleteEnable = UtilityMixin.methods.verificaPermessi(Vue.prototype.user, "pazientepresenze", 8);
            me.filtroPresenze = { idAccettazione: me.idAccettazione };
            me.loadData();
        },
        setCalendar() {
            this.attributes = [];
            let startDate = this.jsonDataAccettazione.dataRicovero !== null ? new Date(this.jsonDataAccettazione.dataRicovero) : new Date();
            let presenze = {
                highlight: {
                    start: { fillMode: "light", color: "green" },
                    base: { fillMode: "light", color: "green" },
                    end: { fillMode: "light", color: "green" },
                },
                dates: { start: startDate, end: new Date() },
            };
            this.attributes.push(presenze);
            this.items.forEach((element) => {
                let startDateSlot = new Date(element.dataOraUscita);
                let endDateSlot = element.dataOraEntrata ? new Date(element.dataOraEntrata) : new Date();
                if (element.tipo === "USCITA" || element.tipo === "ENTRATA") {
                    this.attributes.push({
                        highlight: {
                            start: { fillMode: "light", color: "red" },
                            base: { fillMode: "light", color: "red" },
                            end: { fillMode: "light", color: "red" },
                        },
                        dates: { start: startDateSlot, end: endDateSlot },
                    });
                } else if (element.tipo === "USCITA PROGRAMMATA") {
                    this.attributes.push({
                        highlight: {
                            start: { fillMode: "light", color: "orange" },
                            base: { fillMode: "light", color: "orange" },
                            end: { fillMode: "light", color: "orange" },
                        },
                        dates: { start: new Date(element.dataOraUscitaProgrammata), end: new Date(element.dataOraEntrataProgrammata) },
                    });
                }
            });
        },
        onClickDeleteUScita(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                    title: "Titolo",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + item.id;
                        UtilityMixin.methods.restCallDelete(link, me.resultDeleteResponse, me.resultDeleteError);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        resultDeleteResponse(response) {
            let me = this;
            me.$emit("onDelete", response);
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
            me.loadData();
        },
        resultDeleteError(error) {
            let me = this;
            console.log(error);
            me.showModalLoading = false;
            me.$bvToast.toast("Errore durante l'eliminazione", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        loadData() {
            let me = this;
            if (!me.idAccettazione) {
                console.warn("Non carica il load data: idAccettazione non disponibile");
                return;
            }
            //me.btnDeleteEnable = UtilityMixin.methods.verificaPermessi(Vue.prototype.user, "pazientepresenze", 8);
            me.$emit("beforeLoadData");
            me.filtroPresenze.page = me.currentPage;
            me.filtroPresenze.forPage = me.perPage;
            me.filtroPresenze.idAccettazione = me.idAccettazione;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroPresenze, me.loadDataSuccess, me.loadDataError);
            // console.log("FACCIO IL LOADDAT");
        },
        loadDataSuccess(response) {
            let me = this;
            me.$emit("afterLoadData");
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            this.setCalendar();
        },
        loadDataError(response) {
            let me = this;
            console.error("Errore durante il caricamento dei dati", response);
            me.$emit("afterLoadData", response);
            me.$bvToast.toast("Errore durante il caricamento dei dati", {
                title: "Errore",
                variant: "outline-danger",
                solid: true,
            });
        },
        // ==================== UTILITY ====================
        onCloseModal() {
            let me = this;
            me.jsonDataPresenza = {};
            me.loadData();
        },
        // ==================== GESTIONE MODALE ====================
        onClickPresenzaEdit(item) {
            let me = this;
            me.$refs.cmpRsaSchedaOspiteUsciteEditComponent.init(me.jsonDataAccettazione, item, true, false, false);
        },
        onClickUscitaProgrammata() {
            let me = this;
            me.$refs.cmpRsaSchedaOspiteUsciteEditComponent.init(
                me.jsonDataAccettazione,
                {
                    id: null,
                    idAccettazione: me.idAccettazione,
                    dataOraUscitaProgrammata: null,
                    dataOraUscita: null,
                    dataOraEntrataProgrammata: null,
                    dataOraEntrata: null,
                    tipo: "USCITA PROGRAMMATA",
                    motivo: null,
                    assenteNellaData: null,
                    noteUscitaProgrammata: null,
                },
                true,
                false,
                false,
            );
        },
        onClickRegistraUscita(item) {
            let me = this;
            me.$refs.cmpRsaSchedaOspiteUsciteEditComponent.init(
                me.jsonDataAccettazione,
                {
                    id: item.id,
                    idAccettazione: me.idAccettazione,
                    dataOraUscitaProgrammata: item.dataOraUscitaProgrammata,
                    dataOraUscita: null,
                    dataOraEntrataProgrammata: item.dataOraEntrataProgrammata,
                    dataOraEntrata: null,
                    tipo: "USCITA",
                    motivo: item.motivo,
                    assenteNellaData: null,
                    noteUscitaProgrammata: item.noteUscitaProgrammata,
                    noteEntrata: null,
                    noteUscita: null,
                },
                false,
                false,
                true,
            );
        },
        onClickRegistraEntrata(item) {
            let me = this;
            me.$refs.cmpRsaSchedaOspiteUsciteEditComponent.init(
                me.jsonDataAccettazione,
                {
                    id: item.id,
                    idAccettazione: me.idAccettazione,
                    dataOraUscitaProgrammata: item.dataOraUscitaProgrammata,
                    dataOraUscita: item.dataOraUscita,
                    dataOraEntrataProgrammata: item.dataOraEntrataProgrammata,
                    dataOraEntrata: null,
                    tipo: "ENTRATA",
                    motivo: item.motivo,
                    assenteNellaData: null,
                    noteUscitaProgrammata: item.noteUscitaProgrammata,
                    noteUscita: item.noteUscita,
                    noteEntrata: null,
                },
                false,
                false,
                true,
            );
        },
        onClickVisualizzaUscita(item) {
            let me = this;
            me.$refs.cmpRsaSchedaOspiteUsciteEditComponent.init(
                me.jsonDataAccettazione,
                {
                    id: item.id,
                    idAccettazione: me.idAccettazione,
                    dataOraUscitaProgrammata: item.dataOraUscitaProgrammata,
                    dataOraUscita: item.dataOraUscita,
                    dataOraEntrataProgrammata: item.dataOraEntrataProgrammata,
                    dataOraEntrata: item.dataOraEntrata,
                    tipo: "USCITA COMPLETATA",
                    motivo: item.motivo,
                    assenteNellaData: item.assenteNellaData,
                    noteUscitaProgrammata: item.noteUscitaProgrammata,
                    noteUscita: item.noteUscita,
                    noteEntrata: item.noteEntrata,
                },
                false,
                true,
            );
        },
        // ==================== GESTIONE SELEZIONE ====================
        canSelectItem(item) {
            //Un uscita può essere selezionata solo se è porgrammata ma non ancora effettuate
            return item.dataOraUscitaProgrammata && !item.dataOraUscita;
        },

        /* DA VEDERE BENE COME INTEGRARLO CON IL CSS DI SA-B-TABLE */

        getRowClass(item) {
            let me = this;
            // console.log("getRowClass chiamato per item:", item.id, "modalMode:", me.modalMode, "tipoOperazione:", me.tipoOperazione);
            if (!me.modalMode || me.tipoOperazione !== "USCITA") {
                return "";
            }
            if (!me.canSelectItem(item)) {
                // console.log("Item non selezionabile, applico table-secondary");
                return "table-secondary"; //Riga disabilitata
            }
            if (me.uscitaSelezionata && me.uscitaSelezionata.id === item.id) {
                // console.log("Item selezionato, applico table-success");
                return "table-success"; //Riga selezionata
            }
            // console.log("Item selezionabile, applico table-hover-selectable");
            return "table-hover-selectable"; //Riga selezionabile
        },

        onRowClicked(item) {
            let me = this;
            if (me.modalMode && me.tipoOperazione === "USCITA" && me.canSelectItem(item)) {
                me.onSelectUscita(item);
            }
        },
        onSelectUscita(item) {
            let me = this;
            if (!me.canSelectItem) return;
            me.uscitaSelezionata = item;
            // console.log("Uscita selezionata:", item);
            me.$emit("onSelectUscitaProgrammata", item);
        },
        getSelectButtonVariant(item) {
            if (!this.canSelectItem(item)) return "outline-secondary";
            if (this.uscitaSelezionata && this.uscitaSelezionata.id === item.id) {
                return "success";
            }
            return "outline-primary";
        },

        getSelectButtonTitle(item) {
            if (!this.canSelectItem(item)) return "Uscita già effettuata";
            if (this.uscitaSelezionata && this.uscitaSelezionata.id === item.id) {
                return "Uscita selezionata";
            }
            return "Seleziona questa uscita";
        },

        getSelectButtonIcon(item) {
            if (!this.canSelectItem(item)) return "ban";
            if (this.uscitaSelezionata && this.uscitaSelezionata.id === item.id) {
                return "check-circle";
            }
            return "circle";
        },

        getSelectButtonText(item) {
            if (!this.canSelectItem(item)) return "Non disponibile";
            if (this.uscitaSelezionata && this.uscitaSelezionata.id === item.id) {
                return "Selezionato";
            }
            return "Seleziona";
        },
        getSelectButtonClass(item) {
            if (this.uscitaSelezionata && this.uscitaSelezionata.id === item.id) {
                // console.log("sono entrato nell'if");
                return "btn-selected"; // Classe personalizzata per il pulsante selezionato
            }
            return "";
        },
        // ==================== EMITS ====================
        onSavePresenza() {
            let me = this;
            me.loadData();
        },
        onClickStampa() {
            let me = this;
            me.loadDataResources(me.pathResource + "/printdata/" + me.idAccettazione, null, me.resulResponseStampa, me.resulErrorStampa);
        },
        resulResponseStampa(response) {
            let me = this;
            me.$refs.cmpPrint.print(response.data.data);
        },
        resulErrorStampa(error) {
            console.log(error);
        },
        onDayClick() {},
    },
};
</script>
<style scoped>
/* tr.table-hover-selectable:hover {
    background-color: #f8f9fa !important;
    cursor: pointer;
}

tr.table-success {
    background-color: #00ff3c !important;
}

tr.table-secondary {
    background-color: #e9ecef !important;
    opacity: 0.6;
} */
.btn-selected {
    background-color: #28a745 !important;
    border-color: #28a745 !important;
    color: white !important;
    font-weight: bold !important;
}
.btn-selected:hover {
    background-color: #218838 !important;
    border-color: #1e7e34 !important;
    color: white !important;
}
.bold-label {
    font-weight: bold;
}
.sa-flexbox-body {
    height: 50px;
    flex: 1;
    display: flex;
    flex-direction: row;
    overflow: hidden;
}
</style>
